import {BaseHook, Hook, HookClass, NickProcessArtfact} from '@mrp-brasil/nick-process-commons';
import {Observable, of} from 'rxjs';
import {concatMap} from 'rxjs/operators';

@HookClass('error')
export class ErrorHook extends BaseHook {

    @Hook('f4dcc6e7-e881-45c5-9219-199af40af7c2')
    public throw(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return of(inputArtifact)
            .pipe(concatMap(() => {
                let err: any;
                if (inputArtifact.object.hasOwnProperty('message'))
                    err = new Error(inputArtifact.object.message);
                else
                    err = new Error(inputArtifact.object.data);

                err.__statusCode = inputArtifact.object.config?.statusCode;
                err.__extraData = inputArtifact.object.data;
                err.__flunaError = true;
                throw err;
            }));
    }

}
